<script>
  import Ui from "./Ui.svelte";
  import { Splide, SplideSlide } from '@splidejs/svelte-splide';
  import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
  import '@splidejs/svelte-splide/css';
  import gsap from "gsap";
  import { ScrollTrigger } from "gsap/ScrollTrigger";
  import { MotionPathPlugin } from "gsap/MotionPathPlugin";
  import { onMount, tick } from 'svelte';

  const copy = "/assets_default/images/business/top/mainvisiual/copy.svg"
  const point01 = "/assets_default/images/business/top/mainvisiual/point_01.webp"
  const point02 = "/assets_default/images/business/top/mainvisiual/point_02.webp"
  const point03 = "/assets_default/images/business/top/mainvisiual/point_03.webp"
  const point04 = "/assets_default/images/business/top/mainvisiual/point_04.webp"
  const slide_01 = "/assets_default/images/business/top/mainvisiual/slide_01.webp"
  const slide_02 = "/assets_default/images/business/top/mainvisiual/slide_02.webp"
  const slide_03 = "/assets_default/images/business/top/mainvisiual/slide_03.webp"
  const slide_04 = "/assets_default/images/business/top/mainvisiual/slide_04.webp"
  const slide_05 = "/assets_default/images/business/top/mainvisiual/slide_05.webp"
  const slide_06 = "/assets_default/images/business/top/mainvisiual/slide_06.webp"
  const slide_07 = "/assets_default/images/business/top/mainvisiual/slide_07.webp"
  const slide_08 = "/assets_default/images/business/top/mainvisiual/slide_08.webp"
  const imageMap = [
    {
      class: "size-01",
      src: slide_01
    },
    {
      class: "size-02",
      src: slide_02
    },
    {
      class: "size-03",
      src: slide_03
    },
    {
      class: "size-02",
      src: slide_04
    },
    {
      class: "size-01",
      src: slide_05
    },
    {
      class: "size-02",
      src: slide_06
    },
    {
      class: "size-03",
      src: slide_07
    },
    {
      class: "size-02",
      src: slide_08
    }
  ]

  let splide;
  //----anime:ver01-----
  //%で指定がよいかも
  const circlePath01 = [ //位置動きすぎかも
    { x: 220, y: 100 },
    { x: 150, y: 10.00 },
    { x: 0, y: 0 }
  ];
  const circlePath02 = [
    { x: 220, y: -100 },
    { x: 150, y: -75.00 },
    { x: 0, y: 0 }
  ];
  const circlePath03 = [
    { x: -180, y: 50 },
    { x: -80, y: 85.00 },
    { x: 0, y: 0 }
  ];
  const circlePath04 = [
    { x: -120, y: 150 },
    { x: -10, y: 50 },
    { x: 0, y: 0 }
  ];
  const pointAnime = [
    { target: ".point-01", x: 220,  y: 100,  path: circlePath01 },
    { target: ".point-02", x: 220,  y: -100, path: circlePath02 },
    { target: ".point-03", x: -180, y: 50,   path: circlePath03 },
    { target: ".point-04", x: -120, y: 150, path: circlePath04 }
  ]
  //----anime:ver01-----
  //----anime:ver02-----
  // const targets = [".point-01", ".point-02", ".point-03"];
  //----anime:ver02-----

  gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);
  onMount(async () => {
    await tick();
    // ブラウザのレンダリングサイクルを1つ待つための遅延
    setTimeout(() => {
      // Splideインスタンスが存在すれば、refresh()を呼び出して再計算・再描画させる
      splide?.refresh();
    }, 0);

  //----anime:ver01-----
    pointAnime.forEach(item => {
      gsap.fromTo(item.target,{
        y: item.y,
        x: item.x,
        scale: .6,
        opacity: 0
      },{
        y: 0,
        x: 0,
        scale: 1,
        opacity: 1,
        delay: 1,
        duration: 1.5,
        ease: "power4.inOut",
        motionPath: {
          path: item.path,
          align: false,      // 回転させない
          autoRotate: false
        }
      });
    });
  //----anime:ver01-----
  //----anime:ver02-----
    // gsap.fromTo(targets,{
    //   y: "30%",
    //   opacity: 0
    // },{
    //   y: 0,
    //   opacity: 1,
    //   delay: .5,
    //   duration: 1,
    //   ease: "power4.inOut",
    //   stagger: { amount: .3, from: "center" }
    // });
  //----anime:ver02-----


    gsap.to(".mv-copy", {
      y: 0,
      opacity: 1,
      delay: .5,
      duration: 1.8,
      ease: "power4.out",
    })
  });
</script>

<section class="owd-biz-section:spacing-bottom">
  <div class="mv-top">
  <div class="mv-top-item">
    <div class="mv-copy-box">
      <h1 class="mv-copy"><img src="{copy}" alt="みんなの銀行なら法人口座もシンプルで簡単に"></h1>
    </div>
    <div class="mv-point">
      <img class="point-01" src="{point01}" alt="他行宛振込手数料 業界最安水準">
      <img class="point-02" src="{point02}" alt="口座開設 オンラインで最短翌営業日">
      <img class="point-03" src="{point03}" alt="セキュリティ 安心でスマートなパスキー認証">
      <img class="point-04" src="{point04}" alt="普通預金金利 0.5%">
    </div>
  </div>
    <ul class="owd-list:annotation:number">
      <li>
        <span class="owd-list:annotation:number-text" data-annotation-number="1">
          2026年4月1日時点
        </span>
      </li>
      <li>
        <span class="owd-list:annotation:number-text" data-annotation-number="2">
          金利は年利率・税引前の表示です。利息には復興特別所得税を付加した15.315%の税金がかかります。上記の金利は、市場金利情勢などにより変更になる場合がございます。上記預金は預金保険の対象であり、同保険の範囲内で保護されます。（2026年4月1日時点）
        </span>
      </li>
    </ul>
  </div>


  <div class="scroll-wrap owd-biz-section:spacing-bottom">
    <div class="scroll-container">
    <Splide
      bind:splide
      class="mainvisual-splide"
      options={{
        type: 'loop',
        autoWidth: true ,
        arrows: false,
        gap: 32,
        drag: false,
        pagination: false,
        autoScroll: {
          pauseOnHover: false,
          pauseOnFocus: false,
          rewind: false,
          speed: 0.7
        },
        breakpoints: {
          780: {
            gap: 22,
          }
        }
      }}
      extensions={{ AutoScroll }}
    >
      {#each imageMap as img}
        <SplideSlide class="{img.class}">
          <img src="{img.src}" alt="イメージ" />
        </SplideSlide>
      {/each}
    </Splide>
    </div>
  </div>
  <Ui />
</section>

<style lang="scss">
@use "sass:map";
@use "sass:math";
  .mv{
    &-top{
      width: 95%;
      max-width: 1094px;
      margin: 30px auto 120px;
      // overflow-x: hidden;
      &-item{
        display: grid;
        gap: 59px;
        grid-template-columns: calc((499px/1094px)*100%) 1fr;
        align-items: center;
        margin-bottom: 120px;
      }
    }
    &-copy{
      transform: translateY(110%);
      opacity: 0;
      position: relative;
      z-index: 1;
      &-box{
        overflow-y: hidden;
      }
    }
    &-point{
      $point-w: 535px;
      $point-h: 414px;
      aspect-ratio: math.div($point-w, $point-h);
      position: relative;
      img{
        position: absolute;
        filter: drop-shadow(0 2px 10px rgba(172, 184, 0, 0.25));
      }
      .point{
        &-01{
          $point-w-01: 240px;
          width: calc(($point-w-01 / $point-w) * 100%);
          left: calc((115px / $point-w) * 100%);
        }
        &-02{
          $point-w-02: 171px;
          width: calc(($point-w-02 / $point-w) * 100%);
          top: calc((214px / $point-h) * 100%);
        }
        &-03{
          $point-w-03: 200px;
          width: calc(($point-w-03 / $point-w) * 100%);
          bottom: 0;
          left: calc((286px / $point-w) * 100%);
        }
        &-04{
          $point-w-04: 150px;
          width: calc(($point-w-04 / $point-w) * 100%);
          top: calc((45px / $point-h) * 100%);
          right: 0;
        }
      }
    }
    @include g.mobile () {
      &-top{
        width: calc(100% - (24px*2));
        margin: 42px auto 24px;
        &-item{
          gap: 15px;
          grid-template-columns: 1fr;
          margin-bottom: 40px;
        }
      }
      &-copy{
        width: calc((316px / 363px) * 100%);
      }
      &-point{
        $point-w: 363px;
        $point-h: 290px;
        .point{
          &-01{
          $point-w-01: 168px;
          }
          &-02{
          $point-w-02: 120px;
          }
          &-03{
          $point-w-03: 140px;
          }
        }
      }
    }
  }
  .scroll{
    &-wrap{
      width: 100%;
      filter: drop-shadow(2px 4px 10px rgba(0, 0, 0, 0.2));
      :global(.mainvisual-splide .splide__slide.size-01){
        width: calc((400px / 1440px) * 100%)!important;
      }
      :global(.mainvisual-splide .splide__slide.size-02){
          width: calc((380px / 1440px) * 100%)!important;
      }
      :global(.mainvisual-splide .splide__slide.size-03){
          width: calc((160px / 1440px) * 100%)!important;
      }
      :global(.splide__list) {
        align-items: center;
      }
      @include g.mobile () {
        :global(.mainvisual-splide .splide__slide.size-01){
          width: calc((280px / 390px) * 100%)!important;
        }
        :global(.mainvisual-splide .splide__slide.size-02){
            width: calc((266px / 390px) * 100%)!important;
        }
        :global(.mainvisual-splide .splide__slide.size-03){
            width: calc((112px / 390px) * 100%)!important;
        }
      }
    }
    &-container{
    }
  }
</style>
